import React from 'react';

import { LoadErrorEmptyState, WIDGET_LOAD_ERROR_HEADLINES, type WidgetLoadError } from '~features/empty-states';

function ChartLoadError({ onRetry }: WidgetLoadError) {
  return (
    <LoadErrorEmptyState screen="dashboard" headline={WIDGET_LOAD_ERROR_HEADLINES.chart} onRetry={onRetry} compact />
  );
}

export default ChartLoadError;
